import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const CancelOrderPage = loadable(() =>
  withDefaultLoaderModifiers(import("./CancelOrderPage"))
);
